module.exports = __webpack_public_path__ + "static/media/krx-trading-tut-01.8755acb5.jpg";